module.exports = __webpack_public_path__ + "img/receipt_tip2.b2ed516c.png";